module.exports = __webpack_public_path__ + "static/img/course-system-banner.c33c58c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/course-system-banner.png
// module id = 506
// module chunks = 1